import { ScenarioVO } from '../../vo/scenarii/scenario.vo';
import { Model } from '../../model/model';
import { Scenario } from '@wizeoo/akm-message-lib';
import { VisionVO } from '../../vo/vision/vision.vo';
import { WizConstants } from '../../model/constants';



/**
 * Manager des scenarii
 */
export class ScenarioEngine {
 
  protected _model: Model = null;
  constructor(model: Model) {
    this._model = model;
  }

  /* ################################################
        le constructeur (pour obtenir le bon type)
    ################################################ */

    public newScenarioVO(source?: Scenario): ScenarioVO {
      return new ScenarioVO(this._model, source);
  }

  /**
   * sur changement des scenarii, alimentation du modèle
   * @param scenarii: Scenario[]
   */
  public buildMap(scen: Scenario[]): void {
    const flatList: ScenarioVO[] = scen.map((sce) => this.newScenarioVO(sce));
    this._model.scenariiList = flatList;

    const scenariiMap: Map<string, Map<string, ScenarioVO>> = new Map<string, Map<string, ScenarioVO>>();

    flatList.forEach((svo: ScenarioVO) => {
      if (!scenariiMap.has(svo.visionCode)) {
        scenariiMap.set(svo.visionCode, new Map<string, ScenarioVO>());
      }
      scenariiMap.get(svo.visionCode).set(svo.code, svo);
    });
    this._model.scenariiMap = scenariiMap;
  }

  /**
   * Récupération d'un scen par son couple visionCode / code
   * @param visionCode la vision de rattachement de ce scen
   * @param scenCode Le code du scenar
   */
  public getScenario(visionCode: string, scenCode: string): ScenarioVO {
    // console.log('getScenario',uniqueKey, this.model.scenariiMap?.get(visionCode));
    let svo: ScenarioVO = this._model.scenariiMap?.get(visionCode)?.get(scenCode);
    return svo || null;
  }

  /** retourne les liste des codes de scénarios & le scénario principal */
  public getMainAndAllScens(visionCode: string): string[] {
    const scenarios: string[] = [];
    scenarios.push(WizConstants.BASE_SCENARIO);
    scenarios.push(...this.getAllScens(visionCode));
    return scenarios;
  }

  /** retourne tous les scenar pour le mode multi */
  public getAllScens(visionCode: string, ): string[] {
    let res: string[] = [];
    let scens: Map<string, ScenarioVO> = this._model.scenariiMap?.get(visionCode);
    if(!!scens) {
      res = [...scens.keys()];
    }
    return res;
  }

  /** retourne la pile de scenarii parent d'un scenar pour alimentation des FEis */
  public getScenParents(visionCode: string, scenCode: string ): string[] {
    let res: string[] = [];
    let scen: ScenarioVO = this.getScenario(visionCode, scenCode);
    while(!!scen?.parentCode) {
      res.push(scen.parentCode);
      scen = this.getScenario(visionCode, scen.parentCode);
    }
    return res;
  }

  public getScenarioMapByVision(visionCode: string): Map<string, ScenarioVO> {
    return this._model.scenariiMap?.get(visionCode);
  }

  /**
   * Récupération des scenarii d'une vision pour construction de l'arbre
   * @param visionCode la vision de rattachement
   */
  public getScenarioByVision(visionCode: string): ScenarioVO[] {
    let result: ScenarioVO[] = [];
    // console.log('scen Map', this.model.scenariiMap);
    
    let svoMap: Map<string, ScenarioVO> = this.getScenarioMapByVision(visionCode);
    if(svoMap?.size > 0) {
      result = [...svoMap.values()];
    }
    // console.log('scen result', visionCode, svoMap);
    return result;
  }

  /**
   * suppression des scenarii lors de la suppression d'une vision
   * @param vision 
   */
  public removeForVision(vision: VisionVO): void {
    try {
      // on supprime de la map
      this._model.scenariiMap?.delete(vision.code);
      
      // on supprime de la flatList
      let survivors: ScenarioVO[] = this._model.scenariiList?.filter(scen => scen.visionCode !== vision.code);
      this._model.scenariiList = survivors;

    } catch(e: any) {

    }
  }

  /**
   * Récupération des scenarii d'une vision pour rendu dans la popUp de filtre global
   * gestion de l'ordre et du level pour rendu par ligne
   * @param visionCode la vision de rattachement
   */
  public getScenarioByVisionOrderer(visionCode: string): ScenarioVO[] {
    // let scens: ScenarioVO[] = [];
    let result: ScenarioVO[] = [];
    
    let mainScen: ScenarioVO = this.generateMain(visionCode);
    mainScen.level = 0;

    let svoMap: Map<string, ScenarioVO> = this.getScenarioMapByVision(visionCode);
 
    if(svoMap?.size > 0) {
        [...svoMap.values()].forEach(scen => {
          let parentCode: string = scen.parentCode;
          if(parentCode === WizConstants.BASE_SCENARIO) {
            mainScen.children.push(scen);
          } else {
            let realParent: ScenarioVO = svoMap.get(scen.parentCode);
            if(realParent.children.indexOf(scen) === -1) { // ajout unique
              realParent.children.push(scen);
            }
           
          }
        });
    }  
    
    this.buildFlatSourceRecurse(mainScen, result);
    return result;
  }

  private buildFlatSourceRecurse(item: ScenarioVO, result: ScenarioVO[]): void {
    // j'ajoute l'item s'il n'est pas filtré (mais pas le main)
    // if(item.code !== ViewData.DEFAULT_SCENARIO) {
      result.push(item);
    // }

    // s'il est ouvert, j'ajoute ses enfants
    if (item.children.length > 0) {
      item.children.forEach((subItem: ScenarioVO) => {
        subItem.level = item.level+1;
        this.buildFlatSourceRecurse(subItem, result);
      });
    }
  }

  /** 
   * génère une entrée MAIN pour la vision
   * @param visionCode 
   * @returns 
   */
  public generateMain(visionCode: string): ScenarioVO {
    const scen: ScenarioVO = new ScenarioVO(this._model);
    scen.domain = this._model.domainCode;
    scen.businessUnitCode = this._model.businessUnitCode;
    scen.visionCode = visionCode;
    scen.parentCode = null;
    scen.code = WizConstants.BASE_SCENARIO;
    return scen;
  }

}
